import { SortableContainer } from "react-sortable-hoc";
import React from "react";
import AwardItem from '../Elements/Awards/Item';
import OurTeamItem from '../Elements/OurTeam/Item';
import PartnerItem from '../Elements/Partners/Item';
import IconListItem from '../Elements/IconsList/Item';
import SliderImageItem from '../Elements/SliderImage/Item';
import DirectionActivityItem from '../Elements/DirectionActivity/Item';
import LastProjectsItem from '../Elements/LastProjects/Item';
import BrandItem from '../Elements/OurClients/ItemBrand';
import QuoteItem from '../Elements/OurClients/ItemQuote';
import IndustrialPlatformItem from '../Elements/IndastrialPlatform/Item';
import BestServicesItem from '../Elements/BestServices/Item';
import SimpleListItem from '../Elements/SimpleList/Item';
import ParamsItem from '../Elements/Params/Item'
import SelectedEmployeesItem from '../Elements/SelectedEmployees/Item'

export const AWARD_ITEM = 'award_item';
export const OUR_TEAM_ITEM = 'our_team_item';
export const PARTNER_ITEM = 'partner_item';
export const ICON_LIST_ITEM = 'icon_list_item';
export const SLIDER_IMAGE_ITEM = 'slider_image_item';
export const DIRECTION_ACTIVITY_ITEM = 'direction_activity_item';
export const LAST_PROJECTS_ITEM = 'last_projects_item';
export const BRAND_ITEM = 'brand_item';
export const QUOTE_ITEM = 'quote_item';
export const INDUSTRIAL_PLATFORM_ITEM = 'industrial_platform_item';
export const BEST_SERVICES_ITEM = 'best_services_item';
export const SIMPLE_LIST_ITEM = 'simple_list_item';
export const PARAMS_ITEM = 'params_item';
export const SELECTED_EMPLOYEES_ITEM = 'selected_employee_item'

const components = {
    [AWARD_ITEM]: AwardItem,
    [OUR_TEAM_ITEM]: OurTeamItem,
    [PARTNER_ITEM]: PartnerItem,
    [ICON_LIST_ITEM]: IconListItem,
    [SLIDER_IMAGE_ITEM]: SliderImageItem,
    [DIRECTION_ACTIVITY_ITEM]: DirectionActivityItem,
    [LAST_PROJECTS_ITEM]: LastProjectsItem,
    [BRAND_ITEM]: BrandItem,
    [QUOTE_ITEM]: QuoteItem,
    [INDUSTRIAL_PLATFORM_ITEM]: IndustrialPlatformItem,
    [BEST_SERVICES_ITEM]: BestServicesItem,
    [SIMPLE_LIST_ITEM]: SimpleListItem,
    [PARAMS_ITEM]: ParamsItem,
    [SELECTED_EMPLOYEES_ITEM]: SelectedEmployeesItem
}

const SortableList = SortableContainer(
    ({ titleComponent, item, onChange, onSortEnd, addItem, deleteButtonHandler, children, elements }) => {
        const Item = components[item] || new Error(`Component ${item} not found`);
        return (
            <div className="sortable-list">
                <h2>{titleComponent}</h2>
                {children}
                <div className="row">
                    {elements.map((element, index) => {
                        return (<Item
                            key={`element-${index}`}
                            itemIndex={index}
                            sortIndex={index}
                            index={index}
                            element={element}
                            onChange={onChange}
                            onSortEnd={onSortEnd}
                            addItem={addItem}
                            deleteButtonHandler={deleteButtonHandler}
                        />);
                    })}
                </div>
                <div className="add-element">
                    <div className="button" onClick={addItem}>
                        +
                    </div>
                </div>
            </div>
        );
    });

export default SortableList;
